import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100",
    style: { "z-index": "9999" }
};
const _hoisted_2 = {
    key: 1,
    class: "col bg-white p-4"
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-xxl-7 col-xxxl-6" };
const _hoisted_5 = {
    key: 0,
    class: "row mb-8"
};
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = { class: "card" };
const _hoisted_8 = { class: "card-header" };
const _hoisted_9 = { class: "card-title mb-0" };
const _hoisted_10 = { class: "card-body" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_13 = { class: "card-body text-center" };
const _hoisted_14 = { class: "card-title text-primary mb-3" };
const _hoisted_15 = { class: "d-flex flex-column align-items-center" };
const _hoisted_16 = { class: "text-muted small mb-2" };
const _hoisted_17 = { class: "text-success mb-0" };
const _hoisted_18 = { class: "text-muted mt-2" };
const _hoisted_19 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 bg-white mb-8" };
const _hoisted_20 = { class: "col mb-6" };
const _hoisted_21 = { class: "card radius-10 border-start border-0 border-3 border-info" };
const _hoisted_22 = { class: "card-body" };
const _hoisted_23 = { class: "d-flex align-items-center" };
const _hoisted_24 = { class: "mb-0 text-secondary" };
const _hoisted_25 = { class: "my-1 text-info" };
const _hoisted_26 = { class: "col" };
const _hoisted_27 = { class: "card radius-10 border-start border-0 border-3 border-success" };
const _hoisted_28 = { class: "card-body" };
const _hoisted_29 = { class: "d-flex align-items-center" };
const _hoisted_30 = { class: "mb-0 text-secondary" };
const _hoisted_31 = { class: "my-1 text-primary" };
const _hoisted_32 = { class: "col" };
const _hoisted_33 = { class: "card radius-10 border-start border-0 border-3 border-warning" };
const _hoisted_34 = { class: "card-body" };
const _hoisted_35 = { class: "d-flex align-items-center" };
const _hoisted_36 = { class: "mb-0 text-warning" };
const _hoisted_37 = { class: "my-1 text-warning" };
const _hoisted_38 = {
    key: 1,
    class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
};
const _hoisted_39 = { class: "title" };
const _hoisted_40 = { class: "fw-medium text-muted fs-13 d-block mb-5 text-uppercase" };
const _hoisted_41 = { class: "card-title fw-black mb-0" };
const _hoisted_42 = { class: "card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5" };
const _hoisted_43 = { class: "fw-medium text-muted me-8" };
const _hoisted_44 = {
    value: "0",
    class: "fw-medium"
};
const _hoisted_45 = {
    value: "1",
    class: "fw-medium"
};
const _hoisted_46 = {
    value: "2",
    class: "fw-medium"
};
const _hoisted_47 = {
    key: 2,
    class: "chart bg-white mt-4"
};
const _hoisted_48 = {
    key: 0,
    class: "p-4 text-center"
};
const _hoisted_49 = { class: "text-muted" };
const _hoisted_50 = {
    key: 3,
    class: "chart bg-white mt-4 p-4 text-center"
};
const _hoisted_51 = { class: "text-muted" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_HeadDash = _resolveComponent("HeadDash");
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoaderComponent)
            ]))
            : _createCommentVNode("", true),
        (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_HeadDash, {
                            orderAmount: String(_ctx.getCardValue(0) || '0'),
                            id: "whatHappening"
                        }, null, 8, ["orderAmount"])
                    ])
                ]),
                (_ctx.restaurantsData && _ctx.restaurantsData.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t('dashboard.salesThisWeekByRestaurant')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurantsData, (restaurant) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "col-lg-4 col-md-6 mb-4",
                                                key: restaurant.restaurantId
                                            }, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("h6", _hoisted_14, _toDisplayString(restaurant.restaurantName), 1),
                                                        _createElementVNode("div", _hoisted_15, [
                                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('dashboard.salesThisWeekLabel')), 1),
                                                            _createElementVNode("h4", _hoisted_17, _toDisplayString(Math.floor(restaurant.semaine.actuelle)) + " CHF ", 1),
                                                            _createElementVNode("small", _hoisted_18, _toDisplayString(_ctx.$t('dashboard.vsPreviousWeek')) + " " + _toDisplayString(Math.floor(restaurant.semaine.precedente)) + " CHF ", 1)
                                                        ])
                                                    ])
                                                ])
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('dashboard.salesThisWeekLabel')), 1),
                                        _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.getCardValue(0)) + " CHF", 1)
                                    ]),
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto" }, [
                                        _createElementVNode("i", { class: "fa fa-shopping-cart" })
                                    ], -1))
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('dashboard.thisMonth')), 1),
                                        _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.getCardValue(1)) + " CHF", 1)
                                    ]),
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-ohhappiness text-white ms-auto" }, [
                                        _createElementVNode("i", { class: "fa fa-bar-chart" })
                                    ], -1))
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('dashboard.thisYear')), 1),
                                        _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.getCardValue(2)) + " CHF", 1)
                                    ]),
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-blooker text-white ms-auto" }, [
                                        _createElementVNode("i", { class: "fa fa-users" })
                                    ], -1))
                                ])
                            ])
                        ])
                    ])
                ]),
                (_ctx.chartData && _ctx.chartData.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.getTitleForPeriod), 1),
                            _createElementVNode("h4", _hoisted_41, _toDisplayString(_ctx.getSelectedPeriodTotal) + " CHF ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('dashboard.select')), 1),
                            _withDirectives(_createElementVNode("select", {
                                class: "form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedPeriod) = $event))
                            }, [
                                _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t('dashboard.thisWeek')), 1),
                                _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t('dashboard.thisMonth')), 1),
                                _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.$t('dashboard.thisYear')), 1)
                            ], 512), [
                                [_vModelSelect, _ctx.selectedPeriod]
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.chartData && _ctx.chartData.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        (_ctx.formattedSeries.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('dashboard.noDataAvailable')), 1)
                            ]))
                            : (_openBlock(), _createBlock(_component_apexchart, {
                                key: _ctx.chartKey,
                                type: "line",
                                height: "374",
                                id: "vabeneAdminWeeklySalesChart",
                                options: _ctx.weeklySalesChart,
                                series: _ctx.formattedSeries
                            }, null, 8, ["options", "series"]))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('common.loadingRestaurantData')), 1)
                    ]))
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
